// extracted by mini-css-extract-plugin
export default {"wrapper":"Rz-z","viewport":"Sz-z","container":"Tz-z","slide":"Uz-z"};